export const MESSAGES = {
    SAVE_CHANGES: "Save changes",
    SUPPLIER_CODE: "Supplier code",
    RAG_SOC: "Company name",
    EMAIL: "E-mail",
    USERNAME: "Username",
    EMAIL_REQUIRED: "E-mail is required",
    SUPPLIER_CODE_REQUIRED: "Supplier code is required",
    INVALID_EMAIL_MESSAGE: "Invalid email address.",
    PROFILE_DETAILS: "Profile details",
    REG_SOC_REQUIRED: "Company name is required",
    USERNAME_REQUIRED: "Username is required",
    PROFILE_UPDATED: "Profile details updated successfully",
    SOME_WENT_WRONG: "Something went wrong.",
    PASSWORD_REQUIRED: "Password is required",
    PASSWORD_LENGTH_MESSAGE: "Password must be at least 8 characters long",
    FORGET_PASSWORD_TITLE: "Enter your email to reset your password",
    FORGET_PASSWORD_LINK_MESSAGE: "A reset link has been sent to your email. Please check your inbox.",
    EMAIL_INVALID_FORMAT: "Invalid email format",
    INVALID_CHANGE_PASSWORD_LINK: "The provided link is not correct",
    LOGIN_SUCCESS: "Login successful",
    ACCOUNT_VERIFY_LINK: "An account verification email has been sent with the link.",
    INVALID_VERIFICATION_LINK: "The provided account verification link is not correct.",
    VERIFICATION_SUCCESS: "Your account has been successfully verified.",
    INVENTORY_UPDATED: "Inventory successfully updated",
    SUPPLY_CODE_REQUIRED: "Supplier code is required",
    NEW_PASSWORD_REQUIRED: "New password is required",
    OLD_PASSWORD_REQUIRED: "Old password is required",
    PASSWORD_SHOULD_8_CHARACTERS: "Password must be at least 8 characters long",
    ONE_UPPERCASE_LETTER_REQUIRED: "At least one uppercase letter is required",
    ONE_LOWERCASE_LETTER_REQUIRED: "At least one lowercase letter is required",
    ONE_NUMBER_REQUIRED: "At least one number is required",
    ONE_SPECIAL_CHARACTER_REQUIRED: "At least one special character is required",
    PASSWORD_MUST_MATCH: "Passwords must match",
    PLEASE_CONFIRM_PASSWORD: "Please confirm the password",
    UPLOAD_INVOICE: "Upload invoice",
    PLEASE_WAIT: "Please wait...",
    PLEASE_SAVE_HERE: "Please save here",
    EMAIL_PASSWORD_NOT_SAVED: "E-mail and password not saved",
    LOADING_SUPPLIER_INVOICE: "Loading supplier invoice",
    FORGOT_YOUR_PASSWORD: "Forgot your password?",
    EMAIL_OR_PASSWORD_NOT_SAVED: "The supplier has not saved either the e-mail address or the password.",
    SUPPLIER_CHECK_FAILED: "Supplier check failed",
    LOGIN_ERROR: "A login error occurred",
    PASSWORD: "Password",
    LOGIN: "Login",
    DETAILS_ALREADY_SAVED: "Details already saved?",
    SAVE_PASSWORD: "Save your password",
    RESET_PASSWORD: "Reset password",
    PASSWORD_RESET_LINK_SENT: "A password reset link has been sent to your email. Please check your inbox.",
    MIN_3_CHARACTERS_REQUIRED: "At least 3 characters are required",
    MAX_50_CHARACTERS_ALLOWED: "A maximum of 50 characters is allowed",
    CANCEL: "Cancel",
    SET_NEW_PASSWORD: "Set your new password",
    PASSWORD_COMBINATION: "Create a password with a combination of letters, numbers, and symbols (@,#,%,!)",
    CHANGE_PASSWORD: "Change password",
    ACCOUNT_VERIFICATION: "Account verification",
    ACCOUNT_VERIFIED: "Your account is being verified",
    GO_TO_LOGIN: "Go to login",
    PASSWORD_NOT_LINKED: "The password is not linked to this account",
}
